import { csv } from "d3-fetch";
import GROWTH_FUND from "../data/growth_fund.csv";

const loadData = () => {
  /* Fetch and parse files. */
  return Promise.all([csv(GROWTH_FUND)]).then(([growthFund]) => {
    const data = {};
    const growthFundClean = growthFund.map((item) => {
      const { year, revenue, expenses, balance } = item;
      return {
        year,
        revenue: +revenue,
        expenses: +expenses,
        balance: +balance,
      };
    });

    data.growthFund = growthFundClean;
    return data;
  });
};

export default loadData;
